import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { ChatMessage } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestPending: boolean;
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  messages: ChatMessage[];
  getConversationMessages(
    request: Boundaries["getConversationMessages"]["request"],
  ): void;
}

function useGetConversationMessages(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isGetConversationMessagesRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isGetConversationMessagesRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isGetConversationMessagesRequestFailure,
    ),
    messages: useSelector(selector.getChatMessages),
    getConversationMessages: core.getConversationMessages,
  };
}

export { useGetConversationMessages };
